var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature7Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.35404 3.68607C8.05005 0.990061 12.4211 0.99006 15.1171 3.68607C17.8132 6.38208 17.8132 10.7532 15.1171 13.4492L10.2356 18.3307L5.35404 13.4492C2.65803 10.7532 2.65803 6.38208 5.35404 3.68607ZM10.2356 10.5401C11.3249 10.5401 12.208 9.65697 12.208 8.56762C12.208 7.47827 11.3249 6.59518 10.2356 6.59518C9.14624 6.59518 8.26315 7.47827 8.26315 8.56762C8.26315 9.65697 9.14624 10.5401 10.2356 10.5401Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature7Icon);
export default __webpack_public_path__ + "static/media/feature-7-icon.73a08ae7be637eadd185149d9c78ef27.svg";
export { ForwardRef as ReactComponent };